import { Connection } from "./connections";

enum ApiMethod {
    Create = "create",
    Read = "read",
    Update = "update",
    Destroy = "delete",
    Emit = "emit"
}

export async function create<T>(url: string, args: object) {
    return Connection
        .get()
        .send("sync", {
            method: ApiMethod.Create,
            url,
            data: args
        })
        .then(data => <T>data);
}

export async function read<T>(url: string) {
    return Connection
        .get()
        .send("sync", {
            method: ApiMethod.Read,
            url
        })
        .then(data => <T>data);
}

export async function update<T>(url: string, args: object) {
    return Connection
        .get()
        .send("sync", {
            method: ApiMethod.Update,
            url,
            data: args
        })
        .then(data => <T>data);
}

export async function destroy<T>(url: string) {
    return Connection
        .get()
        .send("sync", {
            method: ApiMethod.Destroy,
            url
        })
        .then(data => <T>data);
}

export async function call<T>(url: string, method: string, args?: object) {
    return Connection
        .get()
        .send("sync", {
            method: ApiMethod.Emit,
            url,
            emit: method,
            data: args ? args : {}
        })
        .then(data => <T>data);
}